import {
  FlatList,
  ListRenderItemInfo,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {minsConvertToHourAndMins} from 'helpers/minsConvertToHourAndMins';
import styleSheet from './styles';

export interface DropDownListForWebProps {
  isOpen: boolean;
  data?: string[];
  onPress(value: string): void;
  label: string | number;
  pickerContainerStyle: object;
  isDurationList?: boolean;
}

const DropDownListForWeb = (props: DropDownListForWebProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const renderItem = ({item}: ListRenderItemInfo<string>) => {
    const selected = props.isDurationList
      ? props.label === minsConvertToHourAndMins(item)
      : props.label === item;

    const valueForLabel = props.isDurationList
      ? minsConvertToHourAndMins(item)
      : item;

    return (
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => {
          props.onPress(item);
        }}
        style={
          selected
            ? styles.selectedItemContainerStyle
            : styles.itemContainerStyle
        }>
        <Text
          style={selected ? styles.selectedTextStyle : styles.optionTextStyle}>
          {valueForLabel}
        </Text>
      </TouchableOpacity>
    );
  };

  const ItemSeparatorComponent = () => {
    return <View style={styles.itemSeparator} />;
  };

  return (
    <>
      {props.isOpen && (
        <FlatList
          data={props.data}
          renderItem={renderItem}
          style={props.pickerContainerStyle}
          ItemSeparatorComponent={ItemSeparatorComponent}
        />
      )}
    </>
  );
};

export default DropDownListForWeb;
